// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"Z0-z","dimensionLabel":"_0-z","styleChooserControlWrapper":"a1-z","styleChooserControl":"b1-z","disabled":"c1-z","giftCard":"d1-z","styleChooserText":"e1-z"};